/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPen = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M1.698 1.698 16.42 4.853l1.522 6.09.36-.357 4.113 4.114-7.714 7.714-4.114-4.114.357-.359-6.09-1.522zM18.3 13.415 13.415 18.3l1.285 1.285 4.885-4.885zM6.1 4.686l3.607 3.607a3 3 0 1 1-1.414 1.414L4.686 6.1l1.86 8.68 6.046 1.512 3.7-3.7-1.512-6.046zM11 10a1 1 0 1 0 .001 2.001A1 1 0 0 0 11 10z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgPen as Pen };
